import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  scrollToCaseShowcaseSection,
  scrollToSection,
  scrollToServicesTabsSection,
  scrollToVideoSection,
} from "../utils/scrollUtils";
import { isHomePath } from "../utils/homePath";

const Navigation = ({ onLinkClick }) => {
  const location = useLocation();
  const { t } = useTranslation();

  const langPrefix = location.pathname.startsWith("/en") ? "/en" : "";
  const sectionItems = [
    { name: t("nav.home"), sectionId: "home" },
    { name: t("nav.offer"), sectionId: "services-tabs" },
    { name: t("nav.projects"), sectionId: "case-showcase" },
    { name: t("nav.about"), sectionId: "video" },
    { name: t("nav.contact"), sectionId: "form" },
  ];

  const handleSectionClick = (e, sectionId) => {
    e.preventDefault();
    // Push hash into history so browser Back returns here instead of leaving site
    try {
      window.history.pushState({ sectionId }, "", `#${sectionId}`);
    } catch (_) {}

    // Mobile navigation locks the body while open. Close it before scrolling so
    // the browser can apply the target position.
    if (onLinkClick) {
      onLinkClick();
    }

    if (sectionId === "home") {
      const element = document.querySelector(".home");
      if (element) {
        try { window.dispatchEvent(new CustomEvent('overlay:show', { detail: { duration: 900 } })); } catch(_) {}
        const rect = element.getBoundingClientRect();
        const pageTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        window.scrollTo({ top: rect.top + pageTop, behavior: 'smooth' });
      }
    } else if (sectionId === "video") {
      scrollToVideoSection();
    } else if (sectionId === "case-showcase") {
      scrollToCaseShowcaseSection();
    } else if (sectionId === "services-tabs") {
      scrollToServicesTabsSection();
    } else {
      scrollToSection(sectionId);
    }
  };

  const isHomeRoute = isHomePath(location.pathname);

  if (isHomeRoute) {
    return (
      <nav className="navigation">
        <ul>
          {sectionItems.map((item, index) => (
            <li key={index}>
              <Link 
                to="#"
                onClick={(e) => handleSectionClick(e, item.sectionId)}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    );
  }

  return (
    <nav className="navigation">
      <ul>
        {sectionItems.map((item, index) => (
          <li key={index}>
            <Link
              to={
                item.sectionId === "home"
                  ? `${langPrefix}/`
                  : `${langPrefix}/#${item.sectionId}`
              }
              onClick={onLinkClick}
            >
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
